import { Outlet } from "react-router-dom"
import { Suspense } from "react"
import { Loader2 } from "lucide-react"
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'
import AppNav from "./AppNav"
import AppFooter from "./AppFooter"
import SmoothScroll from "./SmoothScroll"
import { lazy } from "react"
import { PWAInstallPrompt } from "./PWAInstallPrompt"

const FloatingAssistant = lazy(() => import("./FloatingAssistant"))
const CookieConsent = lazy(() => import("./CookieConsent"))

const AppLayout = () => {
  return (
    <NuqsAdapter>
      <SmoothScroll>
        <div className="flex flex-col min-h-screen 2xl:container 2xl:mx-auto w-full">
          <AppNav />
          <main className="flex-1 w-full">
            <Suspense fallback={<div className="flex min-h-[100vh] w-full items-center justify-center"><Loader2 className="w-8 h-8 animate-spin text-primary" /></div>}>
              <Outlet />
            </Suspense>
          </main>
          <AppFooter />
          <Suspense fallback={null}>
            <FloatingAssistant />
            <PWAInstallPrompt />
            <CookieConsent />
          </Suspense>
        </div>
      </SmoothScroll>
    </NuqsAdapter>
  )
}

export default AppLayout